import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { RED, GREEN, AMBER } from '../../helpers/constants';
import { Button, Icon } from 'semantic-ui-react';
import Filter from '../../components/Filter';

const ROW_TITLES = [
  'Green',
  'Amber',
  'Red',
  'no data',
  'total',
  '% in acceptable threshold'
];
const ROW_COLOURS = [GREEN, AMBER, RED, RED, 'black', 'black'];

class LighthouseSummaryTable extends React.PureComponent {
  state = { display: 'Months' };

  getFilters () {
    return [
      {
        value: 'Months',
        text: 'Monthly',
        id: 0
      },
      {
        value: 'Weeks',
        text: 'Weekly',
        id: 1
      }
      // {
      //   value: 'Days',
      //   text: 'Daily',
      //   id: 2
      // } 
    ];
  }
  onFilterChange = display => {
    this.setState({ display });
  };
  getColumns (summaryData) {
    const filter = this.state.display;

    // reverse data to show most recent on the left of the table
    const dataForTimePeriod = summaryData[filter].asMutable().reverse();
    return [
      {
        Header: 'Threshold',
        accessor: 'title',
        getProps: (state, rowInfo) => {
          let colour = 'black';
          if (rowInfo) {
            colour = ROW_COLOURS[rowInfo.index];
          }
          return {
            style: {
              color: colour,
              fontWeight: 'bolder'
            }
          };
        }
      },

      ...dataForTimePeriod.map(timePeriod => {
        return {
          Header: timePeriod.header,
          id: timePeriod.date,
          accessor: d => d[timePeriod.date],
          getProps: (state, rowInfo) => {
            let colour;
            switch (rowInfo.index) {
              case 0:
                colour = GREEN;
                break;
              case 1:
                colour = AMBER;
                break;
              case 2:
              case 3:
                colour = RED;
                break;
              default:
                colour = 'black';
            }
            return {
              style: {
                color: colour,
                fontWeight: 'bold'
              }
            };
          }
        };
      })
    ];
  }

  convertToCSV(data) {
    const thresholds = ['green', 'amber', 'red', 'noData', 'total', 'acceptable'];
    let weeks = data.Weeks.asMutable().slice().reverse();
    let months = data.Months.asMutable().slice().reverse();

    const weekHeaders = weeks.map(week => week.header).join(',');
    const monthHeaders = months.map(month => month.header).join(',');

    const csvRows = [
      `Threshold,${monthHeaders},${weekHeaders}`
    ];

    thresholds.forEach(threshold => {
      const monthlyValues = months.map(month => month[threshold]).join(',');
      const weeklyValues = weeks.map(week => week[threshold]).join(',');
      csvRows.push(`${threshold},${monthlyValues},${weeklyValues}`);
    });

    return csvRows.join('\n');
  }

  downloadCSV() {
    let data = this.props.summaryData;
    let mode = this.props.mode == "data3g" ? "mobile" : "desktop";
    let filename = `${this.props.prefix}-${this.props.metric}-summary-${mode}.csv`;
    const csvData = this.convertToCSV(data);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    a.click();

    window.URL.revokeObjectURL(url);
  }

  render () {
    const { summaryData, rowHeaders } = this.props;
    let data = [];
    let columns = [];
    const filter = this.state.display;

    if (summaryData && Object.keys(summaryData).length > 0) {
      data = rowHeaders.map((rowHeader, index) => {
        const row = {};
        row.title = ROW_TITLES[index];
        summaryData[filter].forEach(item => {
          row[item.date] = item[rowHeader];
        });
        return row;
      });
      columns = this.getColumns(summaryData);
    }
    return (
      <div className="rum-summary-table">
        <div style={{
          "display": "flex",
          "justifyContent": "space-between"
        }}>
          <div >
            <Filter
              data={this.getFilters()}
              value={this.state.display}
              onChange={this.onFilterChange}
            />
          </div>
          <div >
            <span>
              <Button
                basic
                disabled={this.props.loading}
                loading={this.props.loading}
                icon="download"
                content="Download CSV"
                onClick={this.downloadCSV.bind(this)}
              />
            </span>
            <span> <Button onClick={() => this.props.nextSummaryClicked(this.state.display)}>
              <Button.Content visible>
                <Icon name="arrow left" />
              </Button.Content>
            </Button></span>
            <span> <Button onClick={() => this.props.prevSummaryClicked(this.state.display)}>
              <Button.Content visible>
                <Icon name="arrow right" />
              </Button.Content>
            </Button></span>
          </div>
        </div>
        <ReactTable
          pageSize={data.length}
          columns={columns}
          data={data}
          showPagination={false}
          showPageSizeOptions={false}
          sortable={false}
          loading={this.props.loading}
        />
      </div>
    );
  }
}

LighthouseSummaryTable.propTypes = {
  mode: PropTypes.string,
  prefix: PropTypes.string,
  metric: PropTypes.string,
  summaryData: PropTypes.object,
  rowHeaders: PropTypes.array,
  loading: PropTypes.bool,
  nextSummaryClicked: PropTypes.func,
  prevSummaryClicked: PropTypes.func,
  loadingSummaryNew: PropTypes.bool,
  loadingSummaryOld: PropTypes.bool
};

LighthouseSummaryTable.defaultProps = {
  rowHeaders: ['green', 'amber', 'red', 'noData', 'total', 'acceptable'],
  // loading: false
};

export default LighthouseSummaryTable;
